import { element, useElementProps } from '../../../core/elements';
import Group from '../../../primitives/shape/Group';
import { getFirstItem, getSecondItem } from '../../../primitives/shape/utils/accessors';
import { BarGroup } from '../../bar/elements/bar-group';
import { BarStackHorizontalLabels } from './bar-stack-horizontal-label';
import { BarStackHorizontalMarks } from './bar-stack-horizontal-marks';
import { BarStackHorizontalScalesElement } from './bar-stack-horizontal-scale';
import { getHorizontalBarStacks } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BarStackHorizontal(props) {
  const {
    data,
    top,
    left,
    x0 = getFirstItem,
    x1 = getSecondItem,
    xScale,
    yScale,
    colorScale,
    xAccessor,
    colorAccessor,
    valueAccessor,
    order,
    offset
  } = useElementProps(BarGroup, {
    mergeWith: props
  });
  const scaleProps = useElementProps(BarStackHorizontalScalesElement);
  const barStacks = getHorizontalBarStacks(data, order, scaleProps.normalize ? 'expand' : offset, xAccessor, colorAccessor, valueAccessor, xScale, yScale, colorScale, x0, x1);
  return /*#__PURE__*/_jsxs(Group, {
    top: top,
    left: left,
    children: [/*#__PURE__*/_jsx(BarStackHorizontalMarks, {
      barStacks: barStacks,
      roundedCorners: true
    }), /*#__PURE__*/_jsx(BarStackHorizontalLabels, {
      barStacks: barStacks,
      hide: true
    })]
  });
}
const _BarStackHorizontal = element(BarStackHorizontal, {
  as: BarGroup
});
export { _BarStackHorizontal as BarStackHorizontal };